import parse from 'html-react-parser';
import { FunctionComponent, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Dialog, DialogContent } from '@material-ui/core';

import { findCmsRecordByKey } from '@/applications/CspPortal/Brands/utils';
import { selectDynamicContent } from '@/applications/CspPortal/CSP-Form/selectors';

interface CarrierAlertModalProps {
  open?: boolean;
  onSubmit?: () => void;
}

const CarrierAlertModal: FunctionComponent<CarrierAlertModalProps> = ({
  open = false,
  onSubmit,
}) => {
  const dynamicContent = useSelector(selectDynamicContent);
  const text = useMemo(
    () =>
      findCmsRecordByKey(
        dynamicContent,
        'csp-campaign-register-form#mno-disclaimer'
      )?.text || '',
    [dynamicContent]
  );

  return (
    <Dialog
      data-testid="campaignRegisterFormDialog"
      id="successModal"
      className="success-modal mno-disclaimer"
      fullWidth
      open={open}
      maxWidth="xs"
    >
      <DialogContent className={`success-content-blk text-center`}>
        <div className="paragraph">{parse(text)}</div>
        <ul className="list-inline footer">
          <li>
            <a
              data-testid="campaignRegisterFormDialogOkButton"
              className="primary-btn"
              onClick={onSubmit}
            >
              OK
            </a>
          </li>
        </ul>
      </DialogContent>
    </Dialog>
  );
};

export default CarrierAlertModal;
